var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-btn",
        {
          staticStyle: { float: "right", "margin-top": "0" },
          attrs: { small: "", icon: "", title: _vm.$t("print.print") },
          on: {
            click: function($event) {
              return _vm.generateAndPrintView()
            }
          }
        },
        [_c("v-icon", [_vm._v("print")])],
        1
      ),
      _vm._v(" "),
      _c("div", { ref: "printableElement", staticStyle: { display: "none" } }, [
        _c("h1", [_vm._v(_vm._s(_vm.title))]),
        _vm._v(" "),
        _c("b", [_vm._v(_vm._s(_vm.hostname))]),
        _vm._v(" "),
        _c("div", { domProps: { innerHTML: _vm._s(_vm.modePrintingHtml) } })
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-74d6fb52", { render: render, staticRenderFns: staticRenderFns })
  }
}